import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute flex top-0 left-0 w-full h-full bg-brand-black z-50"
}
const _hoisted_2 = { class: "flex flex-col py-5 px-4 justify-center space-y-4" }
const _hoisted_3 = { class: "flex flex-wrap" }

import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  onIonViewWillEnter,
  useIonRouter,
} from '@ionic/vue';
import {computed, Ref, ref} from 'vue';
import ApiService from "@/services/api/apiService";
import InputCheckbox from "@/components/InputCheckbox.vue";
import {FeedPreference} from "@/services/api/feed/feedPreferencesService";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {useRoute} from "vue-router";



export default /*@__PURE__*/_defineComponent({
  __name: 'FeedPreferencesEdit',
  setup(__props) {

const loading = ref(true)
const ionRouter = useIonRouter()
const route = useRoute()
const busy = ref(false)

const chosenOptions: Ref<number[]> = ref([])
const options: any = ref([])

const preferenceKey: FeedPreference = route.params.key as FeedPreference


onIonViewWillEnter(async () => {

  const userPreference = (await ApiService.FeedPreferences().get())[preferenceKey.toLowerCase()]

  chosenOptions.value = userPreference ? userPreference.map((p:any) => p.id) : []


  await getOptions()

  loading.value = false
})

const getOptions = async () => {

  switch (preferenceKey) {
    case FeedPreference.Kinks: {
      options.value = (await ApiService.Settings().getDesires()).map((g: any) => {
        return {
          text: g.name,
          value: g.id
        }
      })
    }
      break
    case FeedPreference.Interests: {
      options.value = (await ApiService.Settings().getSexualities()).map((g: any) => {
        return {
          text: g.name,
          value: g.id
        }
      })
    }
      break
    case FeedPreference.Gender: {
      options.value = (await ApiService.Settings().getGenders()).map((g: any) => {
        return {
          text: g.name,
          value: g.id
        }
      })
    }
      break
    case FeedPreference.Body: {
      options.value = (await ApiService.Settings().getBodyTypes()).map((g: any) => {
        return {
          text: g.name,
          value: g.id
        }
      })
    }
      break
    case FeedPreference.Drinking: {
      options.value = (await ApiService.Settings().getDrinkingTypes()).map((g: any) => {
        return {
          text: g.name,
          value: g.id
        }
      })
    }
      break
    case FeedPreference.Religion: {
      options.value = (await ApiService.Settings().getReligions()).map((g: any) => {
        return {
          text: g.name,
          value: g.id
        }
      })
    }
      break
    case FeedPreference.Sexuality: {
      options.value = (await ApiService.Settings().getSexualities()).filter((g:any)=>{
        return !g.combination
      }).map((g: any) => {
        return {
          text: g.name,
          value: g.id
        }
      })
    }
      break
    case FeedPreference.Smoking: {
      options.value = (await ApiService.Settings().getSmokingTypes()).map((g: any) => {
        return {
          text: g.name,
          value: g.id
        }
      })
    }
      break
    case FeedPreference.Relationship: {
      options.value = [
        {
          text: 'Single',
          value: 'individual'
        },
        {
          text: 'Couple',
          value: 'joint'
        }
      ]
    }
      break
    case FeedPreference.Piercings: {
      options.value = [
        {
          text: 'Yes',
          value: true
        },
        {
          text: 'No',
          value: false
        }
      ]
    }
      break
    case FeedPreference.Tattoos: {
      options.value = [
        {
          text: 'Yes',
          value: true
        },
        {
          text: 'No',
          value: false
        }
      ]
    }
  }
}


const goBack = async () => {
  if (busy.value) return
  await ionRouter.back()
}

const save = async () => {
  if (busy.value) return
  busy.value = true
  try {
    await ApiService.FeedPreferences().set(preferenceKey, chosenOptions.value)
    await Observable.emit(ObservableEvent.FeedPreferencesChanged)
    ionRouter.back()
    busy.value = false
  } catch (e: any) {
    //   if (!e.data) return
    //   if (e.data.errors) errors.value = e.data.errors
    busy.value = false
  }
}

const title = computed(()=>{
  switch (preferenceKey) {
    default: {
      return preferenceKey.toLowerCase()
    }
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), {
                slot: "start",
                class: "mr-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    onClick: goBack,
                    class: "bg-brand-dark-gray rounded-md"
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("svg", {
                        class: "",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M6 11.9961H18",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }),
                        _createElementVNode("path", {
                          d: "M12 18L6 12L12 6",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), { class: "text-white font-medium text-2xl capitalize" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(title.value), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonButtons), { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    onClick: save,
                    class: "!text-xl"
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("span", { class: "text-brand-lime" }, "Save", -1)
                    ]))]),
                    _: 1
                  }),
                  (busy.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[3] || (_cache[3] = [
                        _createElementVNode("svg", {
                          class: "animate-spin m-auto h-5 w-5 text-brand-lime",
                          xmlns: "http://www.w3.org/2000/svg",
                          fill: "none",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4"
                          }),
                          _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          })
                        ], -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { class: "h-full" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (s, sIndex) => {
                return (_openBlock(), _createBlock(InputCheckbox, {
                  class: "mr-2.5 mb-2.5",
                  key: sIndex,
                  name: "lookingFor",
                  modelValue: chosenOptions.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((chosenOptions).value = $event)),
                  "input-type": "pill",
                  option: s
                }, null, 8, ["modelValue", "option"]))
              }), 128))
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})